<template>
    <div>
        <NavPage></NavPage>
        <div class="content">
            <SlideShow></SlideShow>
        </div>
        <div class="building" v-if="rowData.id != 7">
            <pageContent :solutionItem="itemsDate" pageType="otherPage" />

            <!-- 1建设目标 -->
            <div>
                <h2>{{ rowData.goal.title }}</h2>
                <div v-if="rowData.goal.theme">
                    <h3>{{ rowData.goal.theme }}</h3>
                </div>
                <div v-for="(describedItem, index) in rowData.goal.described" :key="index + 'described'">
                    <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ describedItem }}</p>
                </div>
            </div>
            <el-divider></el-divider>
            <!-- 2系统架构 -->
            <div>
                <h2>{{ rowData.framework.title }}</h2>
                <div v-if="rowData.framework.descri.text">
                    <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ rowData.framework.descri.text }}</p>
                </div>
                <div v-if="rowData.framework.descri.img.src" style="display: flex; justify-content: center;">
                    <img :src="rowData.framework.descri.img.src">
                </div>

            </div>
            <el-divider></el-divider>
            <!-- 智慧园区功能模块 -->
            <h2>{{ rowData.function.title }}</h2>
            <div v-if="rowData.id == 1 || rowData.id == 4 || rowData.id == 5 || rowData.id == 6">
                <h3>{{ rowData.function.label1 }}</h3>
                <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ rowData.function.text }}</p>
                <h3>{{ rowData.function.label2 }}</h3>
                <img v-if="rowData.function.img" :src="rowData.function.img.src" alt="">
                <div v-if="rowData.function.textInfo" :class="[rowData.function.textInfo.textCss]">
                    <div v-for="(i, index) in rowData.function.textInfo.textList" :key="index"
                        :class="[rowData.function.textInfo.itemStyle]">
                        {{ i }}
                    </div>
                </div>
                <h3>{{ rowData.function.label3 }}</h3>
                <div v-for="(factoryItem, index) in rowData.function.described" :key="index + 'factory'"
                    style="padding:0 2%;">
                    <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ factoryItem }}</p>
                </div>
                <div v-if="rowData.function.label4">
                    <h3>{{ rowData.function.label4 }}</h3>
                    <img :src="rowData.function.img3.src" alt="">
                </div>
                <el-divider></el-divider>
            </div>
            <!-- 智慧校园子系统应用场景 -->
            <div v-if="rowData.id == 2">
                <div v-for="(schoolItem, index) in rowData.function.described" :key="index + 'school'">
                    <h3>{{ schoolItem.title }}</h3>
                    <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ schoolItem.text }}</p>
                    <img v-if="schoolItem.img1" :src="schoolItem.img1.src">
                    <img :src="schoolItem.img.src" alt="">
                </div>
            </div>
            <div v-if="rowData.id == 3">
                <div v-for="(hospitalItem, index) in rowData.function.described" :key="index + 'hospital'">
                    <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ hospitalItem }}</p>
                </div>
                <el-divider></el-divider>
            </div>



            <div v-if="rowData.platfromDisplay">
                <h2>{{ rowData.platfromDisplay.title }}</h2>
                <div style="width: 80%; margin: auto;">
                    <img :src="rowData.platfromDisplay.img.src">
                </div>
                <div v-for="(platfromItem, index) in rowData.platfromDisplay.described" :key="index + 'platfrom'">
                    <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ platfromItem }}</p>
                </div>
                <el-divider></el-divider>
            </div>

        </div>
        <div class="building" v-else>
            <h1>{{ rowData.name }}</h1>
            <img :src="rowData.img.src" alt="">
            <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ rowData.text1 }}</p>
            <img :src="rowData.img1.src" alt="">
            <div v-for="(systenItem, index) in rowData.integration1Item" :key="index + 'systen'">
                <h2>{{ systenItem.title }}</h2>
                <p>&nbsp; &nbsp;&nbsp;&nbsp;{{ systenItem.text }}</p>
                <img :src="systenItem.img.src" alt="">
            </div>
        </div>
        <FooterPage></FooterPage>
    </div>
</template>

<script>
import NavPage from '@/components/NavPage.vue'
import SlideShow from '@/components/SlideShow.vue'
import FooterPage from '@/components/FooterPage.vue'
import pageContent from "@/components/pageContent.vue";
import { solutionOptions } from '@/view/solution.js'
export default {
    name: 'BuildingControl',
    components: {
        NavPage,
        SlideShow,
        FooterPage,
        pageContent
    },
    data() {
        return {
            itemsDate: null,
            rowData: []
        }
    },
    watch: {
        '$store.state.custom.productId'(newVal, oldVal) {
            console.log(`count 从 ${oldVal} 变为 ${newVal}`);
            this.rowData = JSON.parse(sessionStorage.getItem('rowData')); // 从 sessionStorage 获取数据
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            });
        }
    },
    created() {
        this.rowData = JSON.parse(sessionStorage.getItem('rowData')); // 从 sessionStorage 获取数据
        const number = Number(this.rowData.id) - 1
        this.itemsDate = solutionOptions[number]
        console.log('thhhA', this.itemsDate);

    },
}
</script>

<style scoped>
.content {
    width: 1340px;
    margin: auto;
}

.building {
    width: 80vw;
    margin: auto;
    text-align: left;
    font-size: 18px;
}


.building img {
    margin: auto;
    width: 75%!important;
    height: 100%;
    object-fit: contain;
    display: block;
}

p {
    line-height: 30px;
}

.textCss {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding: 16px;
    background-color: #f9f9f9;
    border-radius: 10px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.itemStyle {
    width: 18%;
    box-sizing: border-box;
    position: relative;
    padding: 10px 16px;
    background: linear-gradient(135deg, #ffffff, #f1f1f1);
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    color: #333;
    font-size: 15px;
    transition: all 0.3s ease-in-out;
}

.itemStyle:hover {
    cursor: pointer;
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    background: linear-gradient(135deg, #ffffff, #eef);
}
</style>